import * as React from 'react';

import {ActionMenu} from 'shells/action-menu/action-menu';
import {Dialog} from 'shells/dialog/dialog';
// @ts-expect-error - imported from .js/.jsx file
import {ArchiveIcon} from 'shells/icon/svg/archive-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SidebarIconReportsIcon} from 'shells/icon/svg/sidebar-icon-reports';
// @ts-expect-error - imported from .js/.jsx file
import {TrashIcon} from 'shells/icon/svg/trash-icon';

import {appHistory} from '../../../history';

type Props = {
    isArchivedView?: boolean;
    reportUrl: string;
    onDeleteTag: () => void;
    onRestoreTag?: () => void;
};

export function TagRowActionMenu(props: Props) {
    const [isConfirmingDelete, setIsConfirmingDelete] = React.useState<boolean>(false);
    const actionMenuRef = React.useRef();

    return (
        <>
            <ActionMenu
                options={
                    props.isArchivedView
                        ? [
                              {
                                  label: 'Restore',
                                  handleSelect: props.onRestoreTag || (() => {}),
                                  icon: <ArchiveIcon size={16} />,
                              },
                          ]
                        : [
                              {
                                  label: 'View report',
                                  handleSelect: () => appHistory.push(props.reportUrl),
                                  icon: <SidebarIconReportsIcon size={16} />,
                              },
                              {
                                  label: 'Delete',
                                  handleSelect: () => setIsConfirmingDelete(true),
                                  icon: <TrashIcon size={16} />,
                                  variant: 'destructive',
                              },
                          ]
                }
                getRef={(node) => {
                    // @ts-expect-error
                    actionMenuRef.current = node;
                }}
                size='small'
                hasHoverBackground={true}
            />
            {isConfirmingDelete && !props.isArchivedView ? (
                <Dialog
                    anchor={actionMenuRef.current}
                    question='Are you sure you want to delete this tag?'
                    isWarning={true}
                    primaryText='Delete'
                    secondaryText='Cancel'
                    onSecondary={() => setIsConfirmingDelete(false)}
                    onPrimary={() => {
                        props.onDeleteTag();
                        setIsConfirmingDelete(false);
                    }}
                />
            ) : undefined}
        </>
    );
}
